import "./passwordGuidelines.js";
import "./passwordGuidelinesLogic.js";
import "./changePasswordLogic.js";
import "./changePasswordGuidelines.js";
import "./passwordGuidelines.less";



// WEBPACK FOOTER //
// ./src/pages/passwordGuidelines/index.js